import React from 'react';

export default function Header() {
  return (
    <header className="site-header">
      <div className="container nav">
        <a href="#top" className="logo"><span className="logo-dot" />NIVOCAR</a>
        <nav className="nav-links">
          <a href="#top">Início</a>
          <a href="#diferenciais">Plataforma</a>
          <a href="#quem-somos">Quem Somos</a>
          <a href="#portalpay">Integração</a>
          <a href="#form">Contato</a>
        </nav>
        <a href="#form" className="btn btn-primary">Seja um parceiro</a>
      </div>
    </header>
  );
}